<template>
    <div class="wrapper">
        <table>
            <thead>
                <tr class="table_header">
                    <th class="table_header_column">{{ $t('surname') }}</th>
                    <th class="table_header_column">{{ $t('first_name') }}</th>
                    <th class="table_header_column">{{ $t('id') }}</th>
                    <th class="table_header_column">{{ $t('address') }}</th>
                    <th class="table_header_column">{{ $t('birth_date') }}</th>
                    <th>
                        <el-input v-model="search" size="mini" clearable :placeholder="$t('typeToSearch')"
                            class="search-input" />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="i in filteredData" :key="i.device_id" class="table_row" :class="`table_row_${i.id}`">
                    <td>
                        <div class="user-info">
                            <img :src="i.avatar" alt="avatar" class="avatar" />
                            <div class="user-details">
                                <div class="last-name">{{ i.last_name }}</div>
                                <div class="show_on_mobile">{{ i.first_name }}</div>
                                <div class="show_on_mobile location">{{ i.location }}</div>
                                <div class="show_on_mobile birth-date">{{ i.birth_date }}</div>
                            </div>
                        </div>
                    </td>
                    <td>{{ i.first_name }}</td>
                    <td>{{ i.device_id }}</td>
                    <td>{{ i.location }}</td>
                    <td>{{ i.birth_date }}</td>
                    <td class="actions-cell">
                        <el-button size="mini" type="info" @click="handlePersonalData(i)">
                            {{ $t('personal_data') }}
                        </el-button>
                        <el-button size="mini" type="warning" @click="handleChange(i)">
                            {{ $t('edit') }}
                        </el-button>
                        <el-button size="mini" type="primary"
                            @click="handleShow(i.device_id, i.last_name + ' ' + i.first_name, i.birth_date, i.location, i.avatar, i.last_name, i.first_name)">
                            {{ $t('show') }}
                        </el-button>
                        <el-button size="mini" type="success"
                            @click="handleShow2(i.device_id, i.last_name + ' ' + i.first_name, i.birth_date, i.location, i.avatar)">
                            {{ $t('save_data') }}
                        </el-button>

                    </td>
                </tr>
            </tbody>
        </table>

        <el-dialog title="" :visible.sync="dialogVisible" width="800px" @close="resetForm('ruleForm')">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                <el-form-item :label="$t('username')" prop="username">
                    <el-input v-model="ruleForm.username" clearable></el-input>
                </el-form-item>

                <el-form-item :label="$t('first_name')" prop="first_name">
                    <el-input v-model="ruleForm.first_name" clearable></el-input>
                </el-form-item>

                <el-form-item :label="$t('surname')" prop="last_name">
                    <el-input v-model="ruleForm.last_name" clearable></el-input>
                </el-form-item>

                <el-form-item :label="$t('birth_date')" prop="birth_date">
                    <el-date-picker v-model="ruleForm.birth_date" type="date" placeholder="YYYY-MM-DD"
                        style="width: 100%;" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('address')" prop="location">
                    <el-input type="textarea" v-model="ruleForm.location" rows="2"></el-input>
                </el-form-item>

                <el-form-item :label="$t('id')" prop="device_id">
                    <el-input v-model="ruleForm.device_id" clearable></el-input>
                </el-form-item>

                <el-form-item :label="$t('avatar')">
                    <input type='file' id="avatar" />
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">
                    {{ $t('save') }}
                </el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('personal_data')" :visible.sync="showPersonalDataDialog" width="1100px">
            <div v-if="selectedUser">
                <!-- Аватар -->
                <div class="avatar-wrapper" style="text-align: center; margin-bottom: 20px;">
                    <el-avatar :src="selectedUser.avatar" size="large" shape="circle"
                        style="width: 100px; height: 100px;" />
                    <div style="margin-top: 10px;"><strong>{{ $t('avatar') }}</strong></div>
                </div>

                <!-- Основная информация -->
                <el-divider>{{ $t('personal_data') }}</el-divider>
                <el-descriptions :column="2" border>
                    <el-descriptions-item :label="$t('username')">{{ selectedUser.username }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('first_name')">{{ selectedUser.first_name }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('surname')">{{ selectedUser.last_name }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('birth_date')">{{ selectedUser.birth_date }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('gender')">
                        {{ selectedUser.gender === 1 ? $t('male') : (selectedUser.gender === 0 ? $t('female') : '-') }}
                    </el-descriptions-item>
                    <el-descriptions-item :label="$t('address')">{{ selectedUser.location }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('device_id')">{{ selectedUser.device_id }}</el-descriptions-item>
                </el-descriptions>

                <!-- Здоровье -->
                <el-divider>{{ $t('health') }}</el-divider>
                <el-descriptions :column="2" border>
                    <el-descriptions-item v-for="field in medicalFields" :key="field.key" :label="$t(field.label)">
                        {{ formatHealthValue(selectedUser[field.key]) }}
                    </el-descriptions-item>
                </el-descriptions>

                <!-- Образ жизни -->
                <el-divider>{{ $t('lifestyle') }}</el-divider>
                <el-descriptions :column="2" border>
                    <el-descriptions-item :label="$t('smoke')">{{ mapSmoke(selectedUser.smoke) }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('alcohol')">{{ mapAlcohol(selectedUser.alcohol)
                        }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('sport')">{{ mapSport(selectedUser.sport) }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('diet')">{{ mapNutrition(selectedUser.nutrition)
                        }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('eat')">{{ mapEat(selectedUser.eat) }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('emotional')">{{ mapEmotional(selectedUser.emotional_state)
                        }}</el-descriptions-item>
                </el-descriptions>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
    data() {
        return {
            data: [],
            search: "",
            socket_list: [],
            dialogVisible: false,
            currentId: 0,
            imageUrl: '',
            download_url: '',
            ruleForm: {
                username: '',
                first_name: '',
                last_name: '',
                birth_date: '',
                location: '',
                device_id: '',
                gender: '',
                heart: 0,
                breast: 0,
                diabet: 0,
                asthma: 0,
                hypertension: 0,
                medicines: 0,
                allergies: 0,
                operations: 0,
                diseases: 0,
                hereditary_diabetes: 0,
                smoke: 0,
                alcohol: 1,
                sport: 1,
                nutrition: 1,
                eat: 3,
                depression: 0,
                emotional_state: 2,
                psychotropic_drugs: 0
            },
            rules: {
                username: [
                    { required: true, message: 'Please input username', trigger: 'blur' },
                    { min: 3, max: 15, message: 'Length should be 4 to 15', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: 'Please input password', trigger: 'blur' },
                    { min: 6, max: 15, message: 'Length should be 4 to 15', trigger: 'blur' }
                ],
                first_name: [
                    { required: true, message: 'Please input first name', trigger: 'blur' }
                ],
                last_name: [
                    { required: true, message: 'Please input last name', trigger: 'blur' }
                ],
                birth_date: [
                    { required: true, message: 'Please pick a date' }
                ],
                location: [
                    { required: true, message: 'Please input location', trigger: 'blur' }
                ],
                device_id: [
                    { required: true, message: 'Please input device id', trigger: 'blur' }
                ]
            },
            show: true,
            showPersonalDataDialog: false,
            selectedUser: null,
            medicalFields: [
                { key: 'asthma', label: 'asthma' },
                { key: 'diabet', label: 'diabets' },
                { key: 'heart', label: 'heart' },
                { key: 'hypertension', label: 'hypertension' },
                { key: 'breast', label: 'breast' },
                { key: 'psychotropic_drugs', label: 'drugs' },
                { key: 'depression', label: 'depression' },
                { key: 'hereditary_diabetes', label: 'history_diabets' },
                { key: 'medicines', label: 'medicines' },
                { key: 'allergies', label: 'allergia' },
                { key: 'diseases', label: 'disease' },
                { key: 'operations', label: 'operations' },
                { key: 'medicines', label: 'medicines' },
            ],
        };
    },
    computed: {
        filteredData() {
            return this.data.filter((data) => {
                if (!this.search) return true;
                const term = this.search.toLowerCase();
                return (
                    (data.username && data.username.toLowerCase().includes(term)) ||
                    (data.first_name && data.first_name.toLowerCase().includes(term)) ||
                    (data.last_name && data.last_name.toLowerCase().includes(term)) ||
                    (data.location && data.location.toLowerCase().includes(term))
                );
            });
        }
    },
    created() {
        this.getUser();
    },
    methods: {
        getUser() {
            let headers = { Authorization: "Token " + sessionStorage.getItem("key") };
            axios
                .get("users/get/", { headers })
                .then((r) => {
                    this.data = r.data.data;
                    this.sockets(r.data.data);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        sockets(d) {
            for (let i of d) {
                let socket = new WebSocket(
                    "wss://back.cardioservice.com.kz/api/setByte/?wid=" + i.device_id
                );
                socket.onopen = function (e) {
                    console.log("open");
                };
                let period = [];
                let maxx = 0;
                let minn = 0;
                socket.onmessage = function (event) {
                    let d = JSON.parse(event.data)["content"]["pointers"]["content"][
                        "pointers"
                    ];
                    period = period.concat(d.slice(1));
                    if (period.length >= 351) {
                        maxx = Math.max(...period);
                        minn = Math.min(...period);
                        let rowEl = document.querySelector(
                            ".table_row_" + i.device_id.toString()
                        );
                        if (rowEl) {
                            if (minn >= 0 && minn <= 10000000) {
                                rowEl.style.background = "oldlace";
                            } else if (minn > 10000000 && minn <= 16000000) {
                                rowEl.style.background = "#ffef4a";
                            } else {
                                rowEl.style.background = "#f0f9eb";
                            }
                        }
                        period = [];
                    }
                };
                socket.onerror = function (error) {
                    console.log(error);
                };
                this.socket_list.push(socket);
            }
        },
        handleShow(id, name, bd, location, ava, ln, fn) {
            window.location.href = `/profile/staff/detail/?dev_id=${id}&name=${name}&birth_date=${bd}&location=${location}&avatar=${ava}&last_name=${ln}&first_name=${fn}`;
        },
        handleShow2(id, name, bd, location, ava) {
            window.location.href = `/profile/staff/detail/old/?dev_id=${id}&name=${name}&birth_date=${bd}&location=${location}&avatar=${ava}`;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let headers = { "Authorization": "Token " + sessionStorage.getItem('key') }
                    let data = new FormData()
                    const file = document.querySelector('#avatar').files[0];
                    if (file) {
                        data.append('avatar', file);
                    }
                    Object.keys(this.ruleForm).forEach(key => {
                        const value = this.ruleForm[key];
                        if (key === 'birth_date') {
                            data.append('birth_date', moment(value).format('YYYY-MM-DD'));
                        } else if (value) {
                            data.append(key, value);
                        }
                    });
                    console.log(data)
                    axios.put('users/update/' + this.currentId + '/', data, { headers })
                        .then(r => {
                            this.getUser()
                        }, r => {
                            console.log(r)
                        })
                    this.dialogVisible = !this.dialogVisible
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleChange(row) {
            this.dialogVisible = true;
            this.ruleForm = { ...row };
            this.currentId = row.id;
            document.querySelector('#avatar').value = ''
        },

        handleClose(done) {
            this.$confirm('Are you sure to close this dialog?')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },

        handlePersonalData(user) {
            console.log(user);
            this.selectedUser = user;
            this.showPersonalDataDialog = true;
        },

        mapSmoke(value) {
            switch (value) {
                case 0: return this.$t('no');
                case 1: return this.$t('yes');
                case 2: return this.$t('smoke_quit');
                default: return '-';
            }
        },
        mapAlcohol(value) {
            return [this.$t('never'), this.$t('rarely'), this.$t('regular'), this.$t('often')][value] || '-';
        },
        mapSport(value) {
            return [this.$t('never'), this.$t('rarely'), this.$t('aweek'), this.$t('everyday')][value] || '-';
        },
        mapNutrition(value) {
            return [this.$t('other'), this.$t('normal'), this.$t('vegetarian')][value] || '-';
        },
        mapEat(value) {
            return [this.$t('other'), this.$t('1time'), this.$t('2time'), this.$t('3time')][value] || '-';
        },
        mapEmotional(value) {
            return [this.$t('poor'), this.$t('satisfactory'), this.$t('good'), this.$t('excellent')][value] || '-';
        },

        formatHealthValue(value) {
            if (typeof value === 'boolean') {
                return value ? this.$t('yes') : this.$t('no');
            }
            if (value === 1) return this.$t('yes');
            if (value === 0) return this.$t('no');
            return value ? value : '-';
        },
    },
    beforeDestroy() {
        for (let i of this.socket_list) {
            i.close();
        }
    },
};
</script>

<style scoped>
.wrapper {
    padding: 15px;
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 10px;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

thead tr {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
    text-align: left;
}

th,
td {
    padding: 12px 15px;
    vertical-align: middle;
    color: #4a4a4a;
}

tr.table_row {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 0.1);
    transition: background-color 0.3s ease;
}

tr.table_row:hover {
    background-color: #f0f9ff;
}

.user-info {
    display: flex;
    align-items: center;
}

.avatar {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    object-fit: cover;
    box-shadow: 0 1px 4px rgb(0 0 0 / 0.1);
}

.user-details {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
}

.last-name {
    font-weight: 600;
    font-size: 1em;
    color: #333;
}

.location,
.birth-date {
    font-size: 0.85em;
    color: #777;
}

.actions-cell {
    display: flex;
    gap: 6px;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.search-input ::v-deep(.el-input__inner) {
    border-radius: 20px;
    padding-left: 15px;
}

@media (max-width: 800px) {
    .table_header_column {
        display: none;
    }

    .show_on_mobile {
        display: block;
    }

    th,
    td {
        font-size: 0.9em;
    }
}
</style>
